import { csx } from '@vtex/admin-ui'

const styles = {
  container: csx({
    rowGap: '$space-6',
    '& [data-pp-tag]': {
      color: '$black',
    },
  }),
}

export default styles
